import { ITeam } from "@gettactic/api";
import { LockClosedIcon } from "@heroicons/react/outline";
import { UsersIcon } from "@heroicons/react/solid";
import React from "react";
import { TacticTooltip } from "@/ui/index";

export interface TeamListItemProps {
  team: ITeam;
  rightElement?: React.ReactNode | null;
}
export const TeamListItem = ({
  team,
  rightElement = null
}: TeamListItemProps) => (
  <li
    key={team.id}
    className="flex flex-nowrap items-center justify-between px-6 py-4"
  >
    <div className="flex flex-nowrap items-center gap-4">
      <div className="rounded-full bg-secondary-hover p-2">
        <UsersIcon className="h-4 w-4 text-white" />
      </div>
      <h6 className="text-sm font-bold text-tertiary">{team.name}</h6>
      {team.is_hidden ? (
        <TacticTooltip
          reference={
            <div className="flex items-center rounded-2xl bg-amber-50 px-2 text-xs text-amber-500">
              <LockClosedIcon className="h-4 w-4" />
            </div>
          }
          stateProps={{
            placement: "top"
          }}
        >
          <p className="text-base text-amber-500">Hidden</p>
        </TacticTooltip>
      ) : null}
    </div>
    {rightElement}
  </li>
);
